package com.karawek.core.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.karawek.core.ui.theme.CoreShapes
import com.karawek.core.ui.theme.CoreSpacing
import com.karawek.core.ui.theme.CoreTheme

@Composable
fun CoreSurface(
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit,
) {
    Box(
        modifier = modifier
            .background(
                color = CoreTheme.colors.surface,
                shape = CoreShapes.xl,
            )
            .padding(CoreSpacing.md),
    ) {
        content()
    }
}
